import styled from "styled-components";
import {
  GrayColors,
  SolutionColors,
  SolutionColorVariables,
  TextColorNames,
} from "@smartsuite/types";

export const ModalContent = styled.div`
  padding: 25px 30px;
  background-color: ${GrayColors["G-0-5"]};
`;

export const PreviewWrap = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  user-select: none;
`;

export const PreviewItem = styled.div`
  width: 219px;
  height: 171px;
  padding: 16px;
  border-radius: 5px;
`;

export const PreviewLeft = styled(PreviewItem)`
  background-color: ${GrayColors["G-1"]};
`;

export const PreviewRight = styled(PreviewItem)`
  background-color: ${GrayColors["G-0"]};
`;

export const PreviewArrow = styled.div`
  position: absolute;
  left: 200px;
  top: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${TextColorNames.white};
  border: 2px solid ${GrayColors["G-1"]};
  width: 38px;
  height: 38px;
  border-radius: 19px;
`;

export const InputWrap = styled.div`
  margin-top: 24px;

  .error input {
    border-color: ${SolutionColors.darkPrimaryRed};
  }
`;

export const IconsWrap = styled.div`
  background-color: ${SolutionColorVariables.sc1};
  height: 90px;
  width: 90px;
  border-radius: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  &.error {
    background-color: ${SolutionColors.darkPrimaryRed};
  }
`;

export const PreviewLabels = styled.div`
  color: ${TextColorNames.primary};
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  margin-top: 12px;
`;
